import React, { Component } from 'react';
import {
  getUrlQuery,
  getStyleSettingsByStyleId,
  getAllStyles,
} from '../../utils/utils';
import moment from 'moment';
import './admin.css';
import formatcoords from 'formatcoords';

export default class AdminSky extends Component {
  constructor(props) {
    super(props);

    var additionalStateValues = this.getAdditionalStateValues(
      this.props.settings
    );

    let stylesId = getAllStyles(true).map((s) => s.id);

    this.state = {
      isSubtitleRequiresChange: false,
      isAdditionalInfoOpen: false,
      stylesId,
      ...additionalStateValues,
    };
  }

  componentDidMount() {
    this.checkStyleIsCorrect();
  }

  checkStyleIsCorrect() {
    if (this.props.settings) {
      let styleId = this.props.settings.style;
      if (this.state.stylesId.indexOf(styleId) < 0) {
        this.props.onShowError(`Не найден стиль ${styleId}`);
      }
    }
  }

  getAdditionalStateValues(settings) {
    let formattedDate = null;
    if (settings && settings.urlQuery) {
      if (settings.urlQuery.date) {
        var m = moment.utc(settings.urlQuery.date).local();
        formattedDate = m.format('DD.MM.YYYY HH:mm');
      }
    }

    return {
      formattedDate,
    };
  }

  onStyleChange = (event) => {
    var value = event.target.value;
    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };
    var styleSettings = getStyleSettingsByStyleId(value);

    this.props.onSettingsChanged({
      ...settings,
      style: value,
      urlQuery: {
        ...urlQuery,
        style: value,
        ...styleSettings,
      },
    });
  };

  onSizeChange = (event) => {
    var value = event.target.value;

    let split = value.split(/[\sxXхХ]+/);
    let width = parseInt(split[0], 10) * 10;
    let height = parseInt(split[1], 10) * 10;

    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };

    this.props.onSettingsChanged({
      ...settings,
      size: value,
      urlQuery: {
        ...urlQuery,
        printWidth: width,
        printHeight: height,
      },
    });
  };

  onDateChange = (event) => {
    this.dateUpdatedForOrderId = this.props.settings.orderId;

    var value = event.target.value;
    var parsedUtcDate = null;

    var parsedLocalDate = moment(value, 'DD.MM.YYYY HH:mm');
    parsedUtcDate = parsedLocalDate.utc().format();

    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };

    this.setState({
      formattedDate: value,
      isSubtitleRequiresChange: true,
    });

    this.props.onSettingsChanged({
      ...settings,
      urlQuery: {
        ...urlQuery,
        date: parsedUtcDate,
      },
    });
  };

  onInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const type = target.type;
    let value = null;

    if (type == 'checkbox') {
      value = target.checked;
    } else {
      value = target.value;
    }

    var settings = { ...this.props.settings };

    this.props.onSettingsChanged({
      ...settings,
      [name]: value,
    });
  };

  onUrlQueryInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const type = target.type;
    let value = null;

    if (type == 'checkbox') {
      value = target.checked;
    } else {
      value = target.value;
    }

    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };

    if (name === 'centerLon' || name === 'centerLat') {
      this.setState({
        isSubtitleRequiresChange: true,
      });
    }
    this.props.onSettingsChanged({
      ...settings,
      urlQuery: {
        ...urlQuery,
        [name]: value,
      },
    });
  };

  generateConfigFileFromState = () => {
    let query = getUrlQuery(this.props.settings.urlQuery);

    var result = {
      ...this.props.settings,
      urlQuery: query,
    };

    var stringResult = JSON.stringify(result, null, 2);

    console.log(stringResult);
    return stringResult;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    var content = this.generateConfigFileFromState();
    this.props.onSaveFile(content);
  };

  sendToOrder = (event) => {
    event.preventDefault();
    var content = this.generateConfigFileFromState();
    this.props.onSendFileToOrder(content);
  };

  onAdditionalInfoClick = (event) => {
    event.preventDefault();
    this.setState({ isAdditionalInfoOpen: !this.state.isAdditionalInfoOpen });
  };

  copyRedHeart = (event) => {
    event.preventDefault();
    const text = '❤️';
    navigator.clipboard.writeText(text).then(
      () => {
        console.log('Async: Copying to clipboard was successful!');
      },
      (err) => {
        console.error('Async: Could not copy text: ', err);
      }
    );
  };

  getFormattedCoordinates() {
    let formattedCoordinates = '';
    if (
      this.props.settings &&
      this.props.settings.urlQuery &&
      this.props.settings.urlQuery.centerLat
    ) {
      let urlQuery = this.props.settings.urlQuery;
      let latitude = parseFloat(urlQuery.centerLat);
      let longitude = parseFloat(urlQuery.centerLon);
      formattedCoordinates = formatcoords(latitude, longitude).format(
        'D°M\'s"X',
        {
          latLonSeparator: ' ',
          decimalPlaces: 2,
        }
      );
    }
    return formattedCoordinates;
  }

  renderAdditionalInfo() {
    if (!this.state.isAdditionalInfoOpen) return null;
    return (
      <div className="g-bg-gray-light-v5 g-pa-20 g-mb-10">
        <ul className="list-unstyled">
          <li className="g-bg-white g-brd-around g-brd-gray-light-v4 g-brd-left-3 g-brd-primary-left g-rounded-3 g-pa-20 g-mb-7">
            <div className="d-flex justify-content-start">
              <h5 className="g-font-weight-600 g-color-black">
                Сердце для копирования
              </h5>
              {/* <span className="ml-auto small g-color-primary g-px-10">
              Htmlstream
            </span> */}
            </div>
            <p>
              Гарантированно отобразится в макете и будет окрашено в цвет
              текста. ❤️
            </p>
            <div className="d-flex justify-content-end">
              {/* <ul className="u-list-inline">
              <li className="list-inline-item mr-0">
                <img
                  className="g-brd-around g-brd-gray-light-v3 g-pa-2 g-width-40 g-height-40 rounded-circle"
                  src="../../assets/img-temp/100x100/img1.jpg"
                  alt="Image Description"
                />
              </li>
              <li className="list-inline-item mr-0">
                <img
                  className="g-brd-around g-brd-gray-light-v3 g-pa-2 g-width-40 g-height-40 rounded-circle"
                  src="../../assets/img-temp/100x100/img12.jpg"
                  alt="Image Description"
                />
              </li>
              <li className="list-inline-item mr-0">
                <img
                  className="g-brd-around g-brd-gray-light-v3 g-pa-2 g-width-40 g-height-40 rounded-circle"
                  src="../../assets/img-temp/100x100/img3.jpg"
                  alt="Image Description"
                />
              </li>
              <li className="list-inline-item mr-0">
                <img
                  className="g-brd-around g-brd-gray-light-v3 g-pa-2 g-width-40 g-height-40 rounded-circle"
                  src="../../assets/img-temp/100x100/img6.jpg"
                  alt="Image Description"
                />
              </li>
              <li className="list-inline-item mr-0">
                <a
                  className="u-link-v4 d-inline-block g-bg-primary g-color-white g-font-weight-600 g-text-underline--none--hover g-rounded-50 g-py-7 g-px-10"
                  href="#!"
                >
                  9+
                </a>
              </li>
            </ul> */}
              <div className="align-self-center">
                <button
                  className="btn u-btn-outline-primary g-font-weight-600 g-rounded-50"
                  onClick={this.copyRedHeart}
                >
                  Скопировать
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }

  render() {
    let formattedCoordinates = this.getFormattedCoordinates();
    let hangerOptions = [
      'Нет',
      'Рамка',
      'Лента',
      'Крючки',
      'Деревянный подрамник',
    ];
    let isHangerNotValid = false;
    let material = this.props?.settings?.material;
    let hanger = this.props?.settings?.hanger;
    if (material === 'Бумага') {
      if (hanger !== 'Нет' && hanger !== 'Рамка') {
        isHangerNotValid = true;
      }
    } else if (material === 'ПВХ') {
      if (hanger !== 'Нет' && hanger !== 'Рамка' && hanger !== 'Лента') {
        isHangerNotValid = true;
      }
    } else if (material === 'Холст') {
      if (hanger !== 'Крючки' && hanger !== 'Деревянный подрамник') {
        isHangerNotValid = true;
      }
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-row">
          <div className="form-group col-md-3">
            <label for="orderIdInput">Номер заказа</label>
            <input
              type="text"
              className="form-control"
              id="orderIdInput"
              name="orderId"
              value={this.props.settings.orderId}
              onChange={this.onInputChange}
              required
            />
          </div>
          <div className="form-group col-md-3">
            <label for="materialInput">Материал</label>
            <select
              id="materialInput"
              className="form-control"
              name="material"
              value={this.props.settings.material}
              onChange={this.onInputChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              <option value="Бумага">Бумага</option>
              <option value="ПВХ">ПВХ</option>
              <option value="Холст">Холст</option>
            </select>
          </div>
          <div className="form-group col-md-3">
            <label for="sizeInput">Размер</label>
            <select
              id="sizeInput"
              className="form-control"
              value={this.props.settings.size}
              onChange={this.onSizeChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              <option value="21х30 см">21х30 см</option>
              <option value="30х40 см">30х40 см</option>
              <option value="40х50 см">40х50 см</option>
              <option value="50х70 см">50х70 см</option>
            </select>
          </div>
          <div className="form-group col-md-3">
            <label for="styleInput">Стиль</label>
            <select
              id="styleInput"
              className="form-control"
              value={this.props.settings.style}
              onChange={this.onStyleChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              {this.state.stylesId.map((s) => {
                return <option value={s}>{s}</option>;
              })}
            </select>
          </div>
        </div>

        <div className="form-row align-items-center">
          <div className="form-group col-md-2">
            <select
              id="hangerInput"
              className="form-control"
              name="hanger"
              value={this.props.settings.hanger}
              onChange={this.onInputChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              {hangerOptions.map((s) => {
                return <option value={s}>{s}</option>;
              })}
            </select>
          </div>
          <div className="form-group  col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="gridCheck"
                name="isGridEnabled"
                checked={this.props.settings.urlQuery.isGridEnabled}
                onChange={this.onUrlQueryInputChange}
              />
              <label className="form-check-label" for="gridCheck">
                Сетка
              </label>
            </div>
          </div>
          <div className="form-group  col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="сonstellationsCheck"
                name="isConstellationsEnabled"
                checked={this.props.settings.urlQuery.isConstellationsEnabled}
                onChange={this.onUrlQueryInputChange}
              />
              <label className="form-check-label" for="сonstellationsCheck">
                Созвездия
              </label>
            </div>
          </div>
          <div className="form-group  col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="mWCheck"
                name="isMWEnabled"
                checked={this.props.settings.urlQuery.isMWEnabled}
                onChange={this.onUrlQueryInputChange}
              />
              <label className="form-check-label" for="mWCheck">
                Млечный путь
              </label>
            </div>
          </div>
          <div className="form-group  col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="namesCheck"
                name="isNamesEnabled"
                checked={this.props.settings.urlQuery.isNamesEnabled}
                onChange={this.onUrlQueryInputChange}
              />
              <label className="form-check-label" for="namesCheck">
                Названия
              </label>
            </div>
          </div>
          <div className="form-group col-md-2">
            <select
              id="inputLanguage"
              className="form-control"
              name="language"
              value={this.props.settings.urlQuery.language}
              onChange={this.onUrlQueryInputChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              <option value="uk">uk</option>
              <option value="ru">ru</option>
              <option value="la">la</option>
              <option value="en">en</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-3">
            <label for="dateInput">Дата (часовой пояс Украина)</label>

            <input
              type="text"
              className="form-control"
              id="dateInput"
              name="date"
              value={this.state.formattedDate}
              onChange={this.onDateChange}
              required
            />
          </div>
          <div className="form-group col-md-3">
            <label for="dateInput">Дата в UTC</label>

            <input
              type="text"
              className="form-control"
              id="dateInput"
              name="date"
              value={this.props.settings.urlQuery.date}
              readonly
              disabled
            />
          </div>
          <div className="form-group col-md-1">
            <label for="latitudeInput">Широта</label>
            <input
              type="text"
              className="form-control"
              id="latitudeInput"
              name="centerLat"
              value={this.props.settings.urlQuery.centerLat}
              onChange={this.onUrlQueryInputChange}
              required
            />
          </div>

          <div className="form-group col-md-1">
            <label for="longitudeInput">Долгота</label>
            <input
              type="text"
              className="form-control"
              id="longitudeInput"
              name="centerLon"
              value={this.props.settings.urlQuery.centerLon}
              onChange={this.onUrlQueryInputChange}
              required
            />
          </div>
          <div className="form-group col-md-4">
            <label for="formattedCoordinatesInput">
              Координаты в минутах (для подзаголовка)
            </label>

            <input
              type="text"
              className="form-control"
              id="formattedCoordinatesInput"
              name="formattedCoordinates"
              value={formattedCoordinates}
              readonly
              disabled
            />
          </div>
        </div>
        <div
          className={
            'alert alert-warning ' +
            (this.state.isSubtitleRequiresChange ? '' : 'd-none')
          }
          role="alert"
        >
          *При изменении даты или координат необходимо вручную изменить текст
          Подзаголовка. В нём используются координаты в минутах.
        </div>
        <div
          className={'alert alert-warning ' + (isHangerNotValid ? '' : 'd-none')}
          role="alert"
        >
          *Некорректный держатель для выбранного материала.
        </div>
        <div className="form-row">
          <div className="form-group col-md-6">
            <label for="titleInput">Заголовок</label>
            <textarea
              className="form-control"
              id="titleInput"
              rows="5"
              name="title"
              value={this.props.settings.title}
              onChange={this.onInputChange}
            ></textarea>
          </div>
          <div className="form-group col-md-6">
            <label for="subtitleInput">Подзаголовок</label>
            <textarea
              className="form-control"
              id="subtitleInput"
              rows="5"
              name="subtitle"
              value={this.props.settings.subtitle}
              onChange={this.onInputChange}
            ></textarea>
          </div>
        </div>

        {this.renderAdditionalInfo()}

        <button
          className="mt-1 mr-1 btn u-btn-primary g-font-size-13 g-py-10"
          onClick={this.sendToOrder}
        >
          Отправить на order
        </button>
        <button
          type="submit"
          className="mt-1 mr-1 btn u-btn-primary g-font-size-13 g-py-10"
        >
          Скачать файл
        </button>
        <button
          onClick={this.onAdditionalInfoClick}
          className={
            'mt-1 btn g-font-size-13 g-py-10 ' +
            (this.state.isAdditionalInfoOpen
              ? 'u-btn-outline-primary'
              : 'u-btn-primary')
          }
        >
          Дополнительно
        </button>
      </form>
    );
  }
}
